export default __webpack_public_path__ + "static/estra_logo.svg";